import React from 'react'
import { createRoot } from 'react-dom/client'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import ReactQueryClient from 'services/ReactQuery'

// DISABLE SENTRY AS WORKAROUND TO CORS ERRORS
// import initializeSentry from 'services/Sentry'
import './i18n/config'

// implement after standardisation
import CirclesPalette from './common/ui/theme'
import AuthProvider from './context/AuthProvider'
import IdentityProvider from './context/IdentityProvider'
import OrbitFlagProvider from './context/OrbitFlagProvider'
import App from './App'

import './styles/index.css'

// DISABLE SENTRY AS WORKAROUND TO CORS ERRORS
// initializeSentry()

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider reCaptchaKey='6LfQfQIfAAAAAMS3wSV8HEkJZ76AXtWYaipyyPmp'>
      <QueryClientProvider client={ReactQueryClient}>
        <OrbitFlagProvider>
          <AuthProvider>
            <IdentityProvider>
              <BrowserRouter>
                <CirclesPalette>
                  <App />
                </CirclesPalette>
                <ReactQueryDevtools
                  initialIsOpen={false}
                  position='top-right'
                />
              </BrowserRouter>
            </IdentityProvider>
          </AuthProvider>
        </OrbitFlagProvider>
      </QueryClientProvider>
    </GoogleReCaptchaProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
